<template>
    <div class="h-full w-full flex bg-[#ffffff] dark:bg-[#1f1f1f]  items-center justify-center">
        <div class="w-full h-full absolute z-0" style="min-height: 100%;min-width: 100%;">
            <img class="object-fill w-full h-full" src="../assets/banner.png">
        </div>
        <div class="flex flex-col  z-10 w-2/3 h-2/3">
            <n-text class="titleFont text-[80px] ">智联万物，开放共生</n-text>
            <n-text class="titleFont text-[32px] ">让每一次连接，都生长出新的可能</n-text>
            <div class="flex flex-row">
                <n-button class=" w-[200px] h-[80px] mr-8" type="info" @click="gotoWorkSpace()">
                    <n-text class="text-[24px] text-white">
                        进入工作台
                    </n-text>
                </n-button>
                <n-button class=" w-[200px] h-[80px] " type="info"  @click="gotoChat()">
                    <n-text class="text-[24px] text-white">
                        进入聊天
                    </n-text>
                </n-button>
            </div>


        </div>
    </div>
</template>
<script>

export default {
    name: 'MainView',
    components: {
    },

    data() {
        return {

        };
    },
    props: {

    },

    created() { },
    computed() {

    },
    mounted() {


    },
    methods: {


        gotoWorkSpace(url) {
            this.$router.push({
                name: "show",  // 必须使用命名路由

            });

        },
        gotoChat(){
            this.$router.push({
                name: "chat",  // 必须使用命名路由

            });
        }
    }
}
</script>

<style>
.titleFont {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 112px;
    text-align: left;
    font-style: normal;
}
</style>
